/*
 * File: index.tsx
 * Desc: 权限许可组件
 * File Created: 2019-09-29 11:46:00
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { AuthPool } from '..';
import { includePermit } from '../utils';

type AuthPermitProps = {
    require: string[];
    every?: boolean;
    children: React.ReactElement;
};

/** 权限许可组件 */
const AuthPermit = (props: AuthPermitProps) => (
    <AuthPool
        checkPermit={permits =>
            includePermit(permits, props.require, props.every) ? props.children : null
        }
    />
);

export default AuthPermit;
